;(function() {
    const SlideTemplate = `<div class="-slide carousel-cell" data-image-id="{{ IMAGE_ID }}-{{ VARIANT_ID }}" data-slide-index="{{ INDEX }}" tabindex="-1" style="opacity: 0">
        <div class="product-media-container product-media--{{ IMAGE_ID }}-{{ VARIANT_ID }}"
        data-product-single-media-wrapper
        data-thumbnail-id="product-template-{{ IMAGE_ID }}-{{ VARIANT_ID }}"
        data-media-id="product-template-{{ IMAGE_ID }}-{{ VARIANT_ID }}">
            <img src="{{ IMAGE_SRC }}" data-src="{{ IMAGE_SRC }}" loading="lazy" class="product__image" height="1000" width="1000" alt="{{ ALT_TEXT }}">
        </div>
    </div>`;

    const ThumbnailTemplate = `<div class="-thumbnail product-single__thumbnails-item carousel-cell  js-thumb-item" data-slide-index="{{ INDEX }}"
        data-image-id="{{ IMAGE_ID }}-{{ VARIANT_ID }}" tabindex="0"
        data-media-name="{{ IMAGE_ID }}">
        <div class="product-single__thumbnail product-single__thumbnail--{{ SECTION_ID }} js-thumb-item-img-wrap" data-thumbnail-id="product-template-{{ IMAGE_ID }}-{{ VARIANT_ID }}">
            <img src="{{ IMAGE_SRC }}" data-src="{{ IMAGE_SRC }}" loading="lazy" width="68" height="68" data-image-id="{{ IMAGE_ID }}-{{ VARIANT_ID }}" class="js-thumb-item-img" alt="{{ ALT_TEXT }}">
        </div>
    </div>`;

    const VideoSlideTemplate = `<div class="-slide carousel-cell" data-image-id="{{ IMAGE_ID }}-{{ VARIANT_ID }}" data-slide-index="{{ INDEX }}" tabindex="-1" style="opacity: 0">
        <div class="product-media-container product-media--{{ IMAGE_ID }}-{{ VARIANT_ID }}"
        data-product-single-media-wrapper
        data-thumbnail-id="product-template-{{ IMAGE_ID }}-{{ VARIANT_ID }}"
        data-media-id="product-template-{{ IMAGE_ID }}-{{ VARIANT_ID }}">
            <div class="inspirational-video">
                <div class="video-container">
                    <iframe loading="lazy" title="YouTube video player" src="{{ IMAGE_SRC }}"></iframe>
                </div>
            </div>
        </div>
    </div>`;

    const VIDEO_METAFIELD_KEY = 'product_video_link';

    const SLIDER_SLIDES_SELECTOR = '.slides';

    const SLIDER_SLIDE_SELECTOR = '.carousel-cell';

    const SLIDER_NAVIGATION_SELECTOR = '.js-thumb-carousel-nav';

    const THUMBNAIL_SLIDER_SELECTOR = 'thumbnails';

    const ProductSlider = {
        replaceImagesAndThumbnailsForVariant: function(variantId, flickity, sliderContext) {
            this.replaceVariantImages(variantId, flickity, sliderContext);
            this.replaceVariantThumbnails(variantId, flickity, sliderContext);
        },

        replaceVariantImages: function(variantId, flickity, sliderContext) {
            let currentSlides = sliderContext.querySelectorAll(`${SLIDER_SLIDES_SELECTOR} ${SLIDER_SLIDE_SELECTOR}`),
                newSlides = this.getCurrentVariantImages(variantId);

            newSlides.forEach((slide) => flickity.append(slide));

            flickity.remove(currentSlides);
        },

        replaceVariantThumbnails: function(variantId, flickity, sliderContext) {
            let thumbnailSliderElement = document.getElementById(THUMBNAIL_SLIDER_SELECTOR).querySelector(SLIDER_SLIDES_SELECTOR),
                currentThumbnails = thumbnailSliderElement.querySelectorAll(SLIDER_SLIDE_SELECTOR),
                newThumbnails = this.getCurrentVariantThumbnails(variantId),
                thumbnailSlider = Flickity.data(thumbnailSliderElement),
                carouselNav = sliderContext.querySelector(SLIDER_NAVIGATION_SELECTOR);

            if (!thumbnailSlider) {
                console.warn('The thumb slider is not configured for this product.');
                return;
            }

            newThumbnails.forEach((thumb) => thumbnailSlider.append(thumb));
            thumbnailSlider.remove(currentThumbnails);

            theme.ProductGallery.thumbnails(flickity, carouselNav, null, sliderContext);
        },

        getCurrentVariantImages: function(variantId) {
            let selectedVariant = getImageDataForSelectedVariant(variantId),
                productImages = getParentProductImages(),
                productVariantImageSlides = [];

            if (!selectedVariant) {
                return productVariantImageSlides;
            }

            productImages.concat(selectedVariant.images)
                .sort(sortByImagePosition)
                .forEach((image, index) => {
                    if (!image.value) return

                    if (isVideo(image)) {
                        productVariantImageSlides.push(
                            renderTemplate(VideoSlideTemplate, index, image.key, selectedVariant.id, getVideoEmbedUrl(image.value), selectedVariant.altText)
                        );
                        return;
                    }

                    productVariantImageSlides.push(
                        renderTemplate(SlideTemplate,  index, image.key, selectedVariant.id, image.value, selectedVariant.altText)
                    );
                });

            return productVariantImageSlides;
        },

        getCurrentVariantThumbnails: function(variantId) {
            let selectedVariant = getImageDataForSelectedVariant(variantId),
                productImages = getParentProductImages()
                productVariantImageThumbnailSlides = [];

            if (!selectedVariant) {
                return productVariantImageThumbnailSlides;
            }

            productImages.concat(selectedVariant.images)
                .sort(sortByImagePosition)
                .forEach((image, index) => {
                    if (!image.value) return

                    let imageSrc = image.value;

                    if (isVideo(image)) {
                        imageSrc = 'https://img.youtube.com/vi/' + getVideoId(image.value) + '/hqdefault.jpg';
                    }

                    productVariantImageThumbnailSlides.push(
                        renderTemplate(ThumbnailTemplate,  index, image.key, selectedVariant.id, imageSrc, selectedVariant.altText)
                    );
                });

            return productVariantImageThumbnailSlides;
        }
    }

    function getImageDataForSelectedVariant(variantId) {
        let selectedVariant;

        slider_data.variants.forEach(variant => {
            if (variant.id == variantId) {
                selectedVariant = variant;
            }
        });

        return selectedVariant || null;
    }

    function getParentProductImages() {
        return slider_data.product.images;
    }

    function isVideo(image) {
        return image.key === VIDEO_METAFIELD_KEY;
    }

    function getVideoId(videoLink) {
        return videoLink.split('?v=').pop();
    }

    function getVideoEmbedUrl(videoLink) {
        return 'https://www.youtube.com/embed/' + getVideoId(videoLink);
    }

    function sortByImagePosition(image, compareTo) {
        let currentImagePosition = getImagePosition(image),
            compareToImagePosition = getImagePosition(compareTo);

        return currentImagePosition - compareToImagePosition;
    }

    function getImagePosition(image) {
        let configuredImagePosition = 0;

        slider_data.image_positions.forEach(imagePosition => {
            if (imagePosition.key === image.key) {
                configuredImagePosition = imagePosition.value;
            }
        });

        return configuredImagePosition;
    }

    function renderTemplate(template, slideIndex, imageId, referenceId, imageSrc, altText) {
        let renderedElementContainer = document.createElement('div');

        renderedElementContainer.innerHTML = template
            .replace(/{{ IMAGE_ID }}/g, imageId)
            .replace(/{{ VARIANT_ID }}/g, referenceId)
            .replace(/{{ INDEX }}/g, slideIndex)
            .replace(/{{ IMAGE_SRC }}/g, imageSrc)
            .replace(/{{ SECTION_ID }}/g, slider_data.section_id)
            .replace(/{{ ALT_TEXT }}/g, altText);

        return renderedElementContainer.firstChild;
    }

    window.Artdeco = {
        ProductSlider
    };
})()
